import { CSSProperties } from "react";
import { Alert } from "react-bootstrap";
import { Timed } from "./Timed";

export type TimedMessageProps = {
    message: string;
    delay: number; // How many seconds until message should appear
    enabled: boolean; // Whether the message should be enabled or not (on enable, will start timer from beginning)
    style?: CSSProperties | undefined;
    className?: string | undefined;
}

// This component just wraps an alert in the Timed component so we can reuse it in multiple places without having to define the alert component everywhere
export function TimedMessage(props: TimedMessageProps) {
    return (
        <Timed delay={props.delay} enabled={props.enabled}>
            <Alert className={props.className ?? ""} style={props.style}>{<><i className="mdi mdi-information"></i> {props.message}</>}</Alert>
        </Timed>
    );
}
